import { Carousel } from '@design-system';
import classNames from 'classnames';
import { FC } from 'react';

import { InsightItem } from '../../../utils/journals/insights';
import { JournalsCard } from '../JournalsCard';

interface InsightsListProps {
  handleArticleClick: (story: InsightItem, index: number) => void;
  max?: number;
  stories: InsightItem[];
  title: string;
}

export const InsightsList: FC<InsightsListProps> = ({
  handleArticleClick,
  max = 4,
  stories,
  title,
}) => {
  if (stories.length === 0) {
    return null;
  }

  return (
    <Carousel
      headline={title}
      items={stories.slice(0, max).map((story, index) => (
        <div
          key={story.id}
          className={classNames(
            'w-full shrink-0 snap-start scroll-me-20 scroll-ms-20 first:ps-20',
            'md:col-span-3',
            {
              'w-full': stories.length === 0,
              'w-5/6 md:w-full': stories.length > 1,
            },
          )}
        >
          <JournalsCard
            description={story.intro}
            href={`/${story.full_slug}`}
            image={story.image}
            imageRatio={story.ratio || '4/3'}
            onClick={() => {
              handleArticleClick(story, index);
            }}
            publishedAt={story.date}
            readingTime={story.readingTime}
            tag={story.tag}
            title={story.title}
          />
        </div>
      ))}
      perPage={3}
    />
  );
};
